"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  days: ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"],
  daysShort: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
  daysMin: ["Sø", "Ma", "Ti", "On", "To", "Fr", "Lø"],
  months: ["Januar", "Februar", "Mars", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Desember"],
  monthsShort: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
  today: "Idag",
  clear: "Fjern",
  dateFormat: "dd.mm.yyyy",
  timeFormat: "HH:mm",
  firstDay: 1
};
exports.default = _default;